import { useMemo, useCallback } from 'react';
import { Months } from '@/utils/dates';
import DatePeriodComponent from './DatePeriod.component';
import * as Styles from './DatePeriod.styles';

export type PeriodType = {
  month: Months | null | string | undefined;
  year: string | number | null | undefined;
};

type DatePeriodProps = {
  from: PeriodType;
  to?: Partial<PeriodType>;
  actionLabel?: string;
};

const DatePeriodContainer = function ({ from, to, actionLabel }: DatePeriodProps): JSX.Element {
  const formatPeriod = useCallback((period: Partial<PeriodType>): string => {
    return `${period.month}, ${period.year}`;
  }, []);

  const frase = useMemo(() => {
    const endMonth = to?.month && to.month !== 'Month';
    const endYear = to?.year && to.year !== 'Year';
    const hasEndDate = endMonth && endYear;
    if (hasEndDate) {
      return (
        <Styles.Text>
          From <Styles.Highlight>{formatPeriod(from)}</Styles.Highlight> to{' '}
          <Styles.Highlight>{formatPeriod(to)}</Styles.Highlight>
        </Styles.Text>
      );
    }

    return (
      <Styles.Text>
        Since <Styles.Highlight>{formatPeriod(from)}</Styles.Highlight>
        <Styles.Highlight isBold>{actionLabel}</Styles.Highlight>
      </Styles.Text>
    );
  }, [to, from, formatPeriod, actionLabel]);

  return <DatePeriodComponent formattedPeriod={frase} />;
};

export default DatePeriodContainer;
